import { render, staticRenderFns } from "./TriesOverview.vue?vue&type=template&id=da7f27d2&scoped=true"
import script from "./TriesOverview.vue?vue&type=script&lang=js"
export * from "./TriesOverview.vue?vue&type=script&lang=js"
import style0 from "./TriesOverview.vue?vue&type=style&index=0&id=da7f27d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7f27d2",
  null
  
)

export default component.exports